import { FEATURE_FLAGS, FeatureFlags } from "@/constants/featureFlags";
import { getVariant } from "@/utils/amplitude";
import { Variant } from "@amplitude/experiment-js-client";
import { useEffect, useState } from "react";

/**
 * Hook to get the variant of a feature flag
 * @param flagKey - The key of the feature flag
 * @returns The variant of the feature flag. The structure is value = "control" | "variant" | "experiment" and payload JSON object
 * @example
 * const variant = useFeatureFlag(FeatureFlags.PAYMENT_TRUST_SIGNALS);
 * if (variant.value === "variant") {
 *   // do something
 * }
 * if (variant.value === "experiment") {
 *   // do something
 * }
 * if (variant.value === "control") {
 *   // do something
 * }
 * <a href={variant.payload?.url}>{variant.payload?.label}</a>
 */
export const useFeatureFlag = (flagKey: FeatureFlags) => {
  const [variant, setVariant] = useState<Variant | null>(null);
  useEffect(() => {
    getVariant(FEATURE_FLAGS[flagKey]).then((variant) => {
      setVariant(variant);
    });
  }, [flagKey]);
  return variant;
};
